export default __webpack_public_path__ + "static/media/mastercard.c72a1d98.svg";